import React from 'react';
import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import i18n from 'i18n';
import { StatusIcon } from 'components/TableItems';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  type: 'active' | 'inactive' | 'attached' | 'detached';
  hiddenText?: boolean;
}

const ScreenStatesApplications = ({ type, hiddenText }: Props) => {
  const classes = useStyles();

  const RenderItem = {
    active: (
      <>
        <Tooltip title={i18n.t('ACTIVE_KEY')} placement="top" arrow>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.iconContainer}
          >
            <StatusIcon status="success" />
            {!hiddenText && i18n.t('ACTIVE_KEY')}
          </Grid>
        </Tooltip>
      </>
    ),
    inactive: (
      <>
        <Tooltip title={i18n.t('INACTIVE_KEY')} placement="top" arrow>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.iconContainer}
          >
            <StatusIcon status="inactive" />
            {!hiddenText && i18n.t('INACTIVE_KEY')}
          </Grid>
        </Tooltip>
      </>
    ),
    attached: (
      <>
        <Tooltip title={i18n.t('ATTACHED_KEY')} placement="top" arrow>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.iconContainer}
          >
            <StatusIcon status="success" />
            {!hiddenText && i18n.t('ATTACHED_KEY')}
          </Grid>
        </Tooltip>
      </>
    ),
    detached: (
      <>
        <Tooltip title={i18n.t('DETACHED_KEY')} placement="top" arrow>
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.iconContainer}
          >
            <StatusIcon status="inactive" />
            {!hiddenText && i18n.t('DETACHED_KEY')}
          </Grid>
        </Tooltip>
      </>
    ),
  };

  return <Grid className={classes.container}>{RenderItem[type]}</Grid>;
};

export default ScreenStatesApplications;
